import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full justify-between md:flex-wrap" }
const _hoisted_2 = { class: "hidden w-full flex-wrap items-center md:flex md:w-auto md:flex-nowrap" }
const _hoisted_3 = { class: "flex w-full flex-wrap sm:flex-nowrap sm:space-x-2 md:mr-2" }
const _hoisted_4 = { class: "mr-2 md:hidden" }
const _hoisted_5 = {
  key: 0,
  class: "fixed bottom-0 left-0 z-50 w-full rounded-t-3xl bg-white p-4 shadow-2xl"
}
const _hoisted_6 = { class: "flex items-center justify-between p-4" }
const _hoisted_7 = { class: "scrollbar-hide max-h-[75vh] overflow-scroll px-4" }

import { onMounted, computed, ref, nextTick } from "vue";
import { storeToRefs } from "pinia";

import { getTranslation, getGlobalTranslation } from "~/js/composables/translations";
import { blockSmoother, resetSmoother } from "~/js/composables/smoother";

import { Translations } from "~/js/interfaces/translations";
import { Facet, FacetCount } from "~/js/interfaces/facets";

import { usePressStore } from "~/js/store/press";

import FilterCheckbox from "~/vue/molecules/filters/FilterCheckbox.vue";
import FilterCheckboxMobile from "~/vue/molecules/filters/FilterCheckboxMobile.vue";
import FilterMultiselect from "~/vue/molecules/filters/FilterMultiselect.vue";
import FilterMultiselectMobile from "~/vue/molecules/filters/FilterMultiselectMobile.vue";
import FilterSearch from "~/vue/molecules/filters/FilterSearch.vue";
import ButtonFilterMobile from "~/vue/atoms/buttons/ButtonFilterMobile.vue";
import ButtonSecondary from "~/vue/atoms/buttons/ButtonSecondary.vue";
import TextH5 from "~/vue/atoms/texts/TextH5.vue";

interface Props {
	translations?: Translations | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterPress',
  props: {
    translations: { default: null }
  },
  setup(__props: any) {

const props = __props;
const pressStore = usePressStore();
const { documents, pagination, facets, facetsAfterFilter, loading, filters } = storeToRefs(pressStore);
const mobileExpanded = ref(false);

const toggleMobile = () => {
	mobileExpanded.value = !mobileExpanded.value;

	if (mobileExpanded.value) {
		blockSmoother();
	} else {
		resetSmoother();
	}
};

const checkedValue = (fieldName: string) => {
	return (filters.value[fieldName]?.value ?? null) ? filters.value[fieldName].value : false;
};

const yearFilter = computed(() => {
	let filteredFacet = facets.value.find((facet: Facet) => facet.field_name === "postDateYear");
	// let facetAfterFilter = facetsAfterFilter.value.find((facet: Facet) => facet.field_name === 'postDateYear')
	// const currentYear =  new Date().getFullYear()

	// if (filteredFacet) {
	//     filteredFacet.counts.forEach((count: FacetCount) => {

	//         // if (facetAfterFilter) {
	//         //     const existsInFacetAfterFilter = facetAfterFilter.counts.find(facetAfterCount => facetAfterCount.highlighted == count.highlighted)

	//         //     if (existsInFacetAfterFilter) {
	//         //         count.disabled = false
	//         //     } else {
	//         //         count.disabled = true
	//         //     }
	//         // } else {
	//         //     count.disabled = true
	//         // }

	//         if (count.value == currentYear) {
	//             count.value = `${getTranslation(props.translations,'Most recent')} (${new Date().getFullYear()})`
	//         }
	//     })
	// }

	return filteredFacet;
});

const filtersSelected = computed(() => {
	if (filters.value) {
		return filters.value.date.values.length;
	}

	return 0;
});

const updateFacet = (facet: any) => {
	// if (facet.field === 'regulatedInformation') {
	//     nextTick(() => {
	//         pressStore.setFilter('insideInformation', false)
	//     })
	// }

	pressStore.setFilter(facet.field, facet.value);
};

const updateSearch = (search: string) => {
	pressStore.setSearch(search);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (yearFilter.value)
          ? (_openBlock(), _createBlock(FilterMultiselect, {
              key: 0,
              label: _unref(getTranslation)(__props.translations, 'Year'),
              type: "date",
              facet: yearFilter.value,
              loading: _unref(loading),
              translations: __props.translations,
              selected: _unref(filters).date.values,
              "dropdown-position": "left",
              onSetFacet: _cache[0] || (_cache[0] = ($event: any) => (updateFacet($event)))
            }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
          : _createCommentVNode("", true),
        _createVNode(FilterCheckbox, {
          label: _unref(getTranslation)(__props.translations, 'Regulated information'),
          checked: checkedValue('regulatedInformation'),
          type: "regulatedInformation",
          loading: _unref(loading),
          onSetFacet: _cache[1] || (_cache[1] = ($event: any) => (updateFacet($event)))
        }, null, 8, ["label", "checked", "loading"]),
        _createVNode(FilterCheckbox, {
          label: _unref(getTranslation)(__props.translations, 'Inside information'),
          checked: checkedValue('insideInformation'),
          type: "insideInformation",
          loading: _unref(loading),
          onSetFacet: _cache[2] || (_cache[2] = ($event: any) => (updateFacet($event)))
        }, null, 8, ["label", "checked", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ButtonFilterMobile, {
        label: _unref(getGlobalTranslation)('Filter'),
        selected: filtersSelected.value,
        loading: _unref(loading),
        onClick: toggleMobile
      }, null, 8, ["label", "selected", "loading"]),
      _createElementVNode("div", {
        class: "fixed bottom-0 left-0 z-50 block h-screen w-screen bg-black/40 md:hidden",
        onClick: toggleMobile
      }),
      (mobileExpanded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("header", _hoisted_6, [
              _createVNode(TextH5, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getGlobalTranslation)("Filter")), 1)
                ]),
                _: 1
              }),
              _createVNode(ButtonSecondary, {
                ga: {
							category: 'filter-press-mobile-toggle',
							action: 'click',
							label: _unref(getGlobalTranslation)('Close'),
						},
                icon: "times",
                size: "small",
                onClick: toggleMobile
              }, null, 8, ["ga"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (yearFilter.value)
                ? (_openBlock(), _createBlock(FilterMultiselectMobile, {
                    key: 0,
                    label: _unref(getTranslation)(__props.translations, 'Year'),
                    type: "date",
                    facet: yearFilter.value,
                    loading: _unref(loading),
                    translations: __props.translations,
                    selected: _unref(filters).date.values,
                    "dropdown-position": "left",
                    utilities: "w-full mb-4",
                    onSetFacet: _cache[3] || (_cache[3] = ($event: any) => (updateFacet($event)))
                  }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
                : _createCommentVNode("", true),
              _createVNode(FilterCheckboxMobile, {
                label: _unref(getTranslation)(__props.translations, 'Regulated information'),
                checked: checkedValue('regulatedInformation'),
                type: "regulatedInformation",
                utilities: "mb-4",
                loading: _unref(loading),
                onSetFacet: _cache[4] || (_cache[4] = ($event: any) => (updateFacet($event)))
              }, null, 8, ["label", "checked", "loading"]),
              _createVNode(FilterCheckboxMobile, {
                label: _unref(getTranslation)(__props.translations, 'Inside information'),
                checked: checkedValue('insideInformation'),
                disabled: !checkedValue('regulatedInformation'),
                type: "insideInformation",
                utilities: "mb-4",
                loading: _unref(loading),
                onSetFacet: _cache[5] || (_cache[5] = ($event: any) => (updateFacet($event)))
              }, null, 8, ["label", "checked", "disabled", "loading"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})